module.exports = __webpack_public_path__ + "img/thumbnail_AmericanAlligator_m_normal.0b2b8e38.png";